import React, { Fragment } from "react";
import { Card, CardBody, Col, Row, CardText, Button } from "reactstrap";
import classnames from "classnames";
import { Link } from "react-router-dom";

export interface StatisticsBoxProps {
  button?: {
    title: string;
    data: object | undefined;
    path: string;
  };
  title: string;
  description?: string;
  value: number | string | undefined;
  isPercent?: boolean;
  results?: {
    title: string;
    value: number | string | undefined;
    isPercent?: boolean;
  }[];
}

const StatisticBox: React.FC<StatisticsBoxProps> = (props) => {
  const value =
    typeof props.value === "number"
      ? props.value.toLocaleString()
      : props.value;
  const button = props.button;

  return (
    <div className="no-line-spacing text-center box-shadow">
      <Card>
        {props ? (
          <Fragment>
            <CardBody>
              <div className="text-primary text-uppercase text-truncate fs-9 fw-6 mx-2">
                {props.title}
              </div>
              <div
                className="text-primary fs-9 fw-6 py-2"
                style={{ marginTop: "1em", marginBottom: "-1em" }}
              >
                <div className="d-flex align-items-top justify-content-center">
                  <span className="fs-1">
                    {value !== void 0 ? value : <Fragment>...</Fragment>}
                  </span>
                  {value !== void 0 && props.isPercent && (
                    <span className="fs-5">%</span>
                  )}
                </div>
                <div className="text-uppercase fw-6">
                  {value !== void 0 && props.description ? (
                    props.description
                  ) : (
                    <Fragment>&nbsp;</Fragment>
                  )}
                </div>
              </div>
            </CardBody>

            {!!props.results && props.results.length > 0 && (
              <Row className="no-gutters border-top bg-panel-dark">
                {props.results.slice(0, 3).map((stat, index, arr) => (
                  <Col
                    xs={12 / Math.min(arr.length, 3)}
                    className={classnames({
                      "my-3": true,
                      "border-left": index !== 0,
                    })}
                    key={index}
                  >
                    <div className="text-uppercase fs-10 fw-6 mb-1 text-truncate">
                      {stat.title}
                    </div>
                    <div className="d-flex align-items-top justify-content-center text-light fw-6">
                      <span className="fs-7">
                        {stat.value !== void 0 ? typeof stat.value === "number" ? stat.value.toLocaleString() : stat.value : "..."}
                      </span>
                      {stat.value !== void 0 && stat.isPercent && (
                        <span className="fs-8">%</span>
                      )}
                    </div>
                  </Col>
                ))}
              </Row>
            )}
            {button ? (
              <Fragment>
                <nav className="border-top nav-menu">
                  <ul className="mainmenu">
                    <li>
                      <Link
                        className="btn"
                        to={{
                          pathname: button.path,
                          state: {
                            event: button.data,
                          },
                        }}
                      >
                        {button.title}
                      </Link>
                    </li>
                  </ul>
                </nav>
              </Fragment>
            ) : null}
          </Fragment>
        ) : (
          <CardBody>
            <CardText>No data available</CardText>
          </CardBody>
        )}
      </Card>
    </div>
  );
};

export default StatisticBox;
